
function loadPriceList () {
  const priceList = [
    { value: 300, key: '300' },
    { value: 500, key: '500' },
    { value: 1000, key: '1,000' },
    { value: 3000, key: '3,000' },
    { value: 5000, key: '5,000' },
    { value: 10000, key: '10,000' },
    { value: 20000, key: '20,000' },
    { value: 50000, key: '50,000' },
    { value: 300, key: 'Custom' },
  ];

  return priceList;
}

function loadDefaultPrice () {

}

export {
  loadPriceList,
  loadDefaultPrice,
};



// WEBPACK FOOTER //
// ./src/modules/api/credit.js